import { Grid, Text, useTheme } from '@simplywallst/ui-core';

import AddToListSolid from '@simplywallst/ui-core/icons/AddToListSolid';

type Props = {
  label: string;
};

export const CreateNewWatchlistOption = ({ label }: Props) => {
  const theme = useTheme();
  return (
    <Grid templateColumns="36px max-content" gap="8px" alignItems="start">
      <Grid
        minHeight="36px"
        minWidth="36px"
        alignItems="center"
        justifyContent="end"
      >
        <AddToListSolid height="28" width="28" fill={theme.color.chart01} />
      </Grid>
      <Grid
        alignItems="start"
        paddingTop="x1"
        paddingBottom="x1"
        paddingRight="x1"
      >
        <Text typography="xSmall" color="spaceGray" isTruncated>
          {label}
        </Text>
      </Grid>
    </Grid>
  );
};
